import {loadUTMParams} from "../../utils/Referrer";

export const merchantBuiltinFunctions = {};

// These will also be overwritten by the settings from the SDK initOptions
export const merchantBuiltinVariables = {
    "utm": loadUTMParams(),
};
